export default "__VITE_ASSET__BkJEpwYG__"